module.exports = {"dropDownPlaceholder":"Se connecter sans Adobe ID"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/fr_fr.json
// module id = 929
// module chunks = 0